import { Environments } from './../enums/enivronments';
export class MenuItem {
    public static toCollection(data: any) {
        return data.map((item: any) => {
            return new MenuItem(item);
        });
    }

    public path: string;
    public label: string;
    public icon: string;
    public childrens: MenuItem[];
    public allow: Environments[];

    public constructor(data?: any) {
        this.path = (data && data.path) ? data.path : '/';
        this.label = (data && data.label) ? data.label : '';
        this.icon = (data && data.icon) ? data.icon : 'el-icon-files';
        this.childrens = (data && data.childrens) ? data.childrens : [];
        this.allow = (data && data.allow) ? data.allow : [];
    }
}
